module.exports = __webpack_public_path__ + "fonts/ralewayblack.76c58fb.ttf";